<template>
  <ul class="pagination" v-if="pages > 1">
    <li
      class="page"
      v-for="page in pagesArray"
      v-bind:class="{
                    active: page.page === currentPage,
                    'separator-before': page.separator === 'before',
                    'separator-after': page.separator === 'after',
                }"
      @click="$emit('setPage',page.page)"
      :key="page.page"
    >
      {{ page.label }}
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.pagination {
  float: left;
  width: 100%;
  text-align: right;
  display: block;
  .page {
    cursor: pointer;
    display: inline-block;
    min-width: 40px;
    height: 40px;
    background: #fff;
    box-shadow: 0 0 2px rgba(0,0,0,.5);
    border-radius: 3px;
    text-align: center;
    margin-left: 10px;
    vertical-align: middle;
    line-height: 40px;
    color: var(--primary);
    font-weight: 600;
    margin-bottom: 10px;
    &.active {
      background: var(--primary);
      color: #fff;
    }
    @media(max-width: 500px) {
      font-size: 13px;
      width: 30px;
      height: 30px;
      line-height: 30px;
    }
    &.separator-before {
      margin-left: 30px;
      position: relative;
      &:before {
        position: absolute;
        content: "...";
        left: -21px;
        top: 0;
        margin-top: -2px;
        color: #888;
      }
    }
    &.separator-after {
      margin-right: 20px;
      position: relative;
      &:before {
        position: absolute;
        content: "...";
        right: -21px;
        top: 0;
        margin-top: -2px;
        color: #888;
      }
    }
  }
}
</style>
<script>
export default {
  name: "pagination",
  props: {
    name: {
      type: String,
      default: "grid",
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pages: Math.ceil(this.total / this.perPage),
    };
  },
  computed: {
    pagesArray() {
      let pages = [];
      if (this.pages < 10) {
        for (let i = 1; i <= this.pages; i++) {
          pages.push({
            label: i,
            page: i,
            separator: null,
          });
        }
      } else {
        let currentPage = this.currentPage;
        for (let i = currentPage - 5; i <= currentPage + 5; i++) {
          pages.push({
            label: i,
            page: i,
            separator: null,
          });
        }
        pages = pages.filter((i) => i.page > 0 && i.page <= this.pages);
        let startSlide = 0;
        let currentPageIndex =
          pages.findIndex((i) => i.page === currentPage) - 2;
        if (this.pages - currentPage <= 2) {
          startSlide = this.pages - currentPage + 1;
        } else {
          let currentPageIndex =
            pages.findIndex((i) => i.page === currentPage) - 2;
          startSlide = Math.max(currentPageIndex, 0);
        }

        pages = pages.slice(startSlide, 5 + startSlide);
        if (currentPage > 3) {
          pages = [
            { label: 1, page: 1, separator: "after" },
            ...pages,
          ];
        }
        if (pages[pages.length - 1].page < this.pages) {
          pages = [
            ...pages,
            {
              label: this.pages,
              page: this.pages,
              separator: "before",
            },
          ];
        }
      }
      return pages;
    },
  },
  methods: {
    setPage(page) {
      this.currentPage = page;
      this.$emit("page", page);
    },
  },
  watch: {
    total() {
      this.pages = Math.ceil(this.total / this.perPage);
    },
  },
};
</script>
